class ShippingDrawer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.isOpen = false;
        this.initElements();
        this.initEvents();
    }

    initElements() {
        this.openButton = document.querySelectorAll('[data-open-shipping-drawer]');
        this.closeButtons = this.querySelectorAll('[data-close-shipping-drawer]');
    }

    initEvents() {
        this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                if (this.isOpen) {
                    this.close();
                }
            });
        })

        this.openButton.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                if (!this.isOpen) {
                    this.open();
                }
            });
        })
    }

    close() {
        this.isOpen = false;
        this.classList.remove('open');
    }

    open() {
        this.isOpen = true;
        this.classList.add('open');
    }
}

if (!customElements.get('shipping-drawer')){
    customElements.define('shipping-drawer', ShippingDrawer);
}
